import { Tooltip as TooltipMui } from '@material-ui/core';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';

const Tooltip = ({ children, title }) => {
  const {
    css,
    theme: { spacing },
  } = useStyles();

  return (
    <TooltipMui
      classes={{
        tooltip: css({
          margin: spacing(1),
        }),
      }}
      placement="top"
      title={title}
    >
      {children}
    </TooltipMui>
  );
};

Tooltip.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
};

export default Tooltip;
